import logoBlack from "@images/logos/logoBlack.png";
import downloadImg from "@images/misc/download-arrow.png";
import GeneralStrings from "@strings/GeneralStrings.json";
import BeatStarsMarketplace from "@components/BeatStore/BeatStarsMarketplace";
import "./BeatStore.scss";

const BeatStore = () => {
  const beatStoreStrings = GeneralStrings.beatStore;

  return (
    <section className="beat-store section" id="store">
      <div className="container">
        <div className="row">
          <div className="title-area">
            <h2>{beatStoreStrings.title}</h2>
            <div className="separator">
              <img src={logoBlack} className="seperator-img" alt="Logo" />
            </div>
            <p
              className="beat-store-description"
              dangerouslySetInnerHTML={{
                __html: beatStoreStrings.descriptionHtml.replace(
                  "{imgLoc}",
                  downloadImg
                ),
              }}
            />
          </div>
        </div>

        <div className="row marketplace-iframe">
          <BeatStarsMarketplace height={750} />
        </div>
      </div>
    </section>
  );
};

export default BeatStore;
